/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
type PdpRespSimilarItemsFooter_similarGridItems$ref = any;
export type PdpRespContainer_similarGridItems$ref = any;
export type PdpRespContainer_similarGridItems = {
    readonly " $fragmentRefs": PdpRespSimilarItemsFooter_similarGridItems$ref;
    readonly " $refType": PdpRespContainer_similarGridItems$ref;
};



const node: ReaderFragment = ({
    "kind": "Fragment",
    "name": "PdpRespContainer_similarGridItems",
    "type": "moreLikeThisConnection",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "PdpRespSimilarItemsFooter_similarGridItems",
            "args": null
        }
    ]
} as any);
(node as any).hash = '9592948420bef0dc097ca93ed76bec16';
export default node;
